// web/src/components/layout/Topbar.jsx
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Topbar.css";

// ✅ Firebase Auth (logout real)
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/firebase"; // ✅ CAMINHO CORRETO (layout -> src/firebase)

export default function Topbar() {
  const navigate = useNavigate();

  // (Se quiser, depois a gente puxa isso do Firestore / claims)
  const adminName = "Admin One Love";

  const [openMenuUser, setOpenMenuUser] = useState(false);
  const menuRef = useRef(null);

  // Fecha o dropdown ao clicar fora
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuUser(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // (Opcional) fecha com ESC
  useEffect(() => {
    function handleEsc(e) {
      if (e.key === "Escape") setOpenMenuUser(false);
    }
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  const handleLogout = async () => {
    try {
      // ✅ encerra sessão do Firebase
      await signOut(auth);
    } catch (e) {
      console.error("Erro ao sair:", e);
    } finally {
      // ✅ fecha o mega menu se estiver aberto
      window.dispatchEvent(new Event("closeMainMenu"));

      // ✅ volta pro login (SPA)
      navigate("/", { replace: true });
    }
  };

  // 🔥 Dispara evento global para abrir/fechar o MENU PRINCIPAL (Sidebar estilo Ideris)
  const handleToggleMainMenu = () => {
    window.dispatchEvent(new Event("toggleMainMenu"));
  };

  return (
    <header className="topbar">
      {/* ESQUERDA — Logo + Hamburguer */}
      <div className="topbar-left">
        <div
          className="topbar-logo"
          role="button"
          tabIndex={0}
          onClick={() => navigate("/dashboard")}
          onKeyDown={(e) => {
            if (e.key === "Enter") navigate("/dashboard");
          }}
          title="Ir para o Dashboard"
        >
          <img
            src="/logo_onelove.png"
            alt="One Love Logo"
            className="topbar-logo-image"
          />
          <span className="topbar-logo-text">One Love</span>
        </div>

        <button
          type="button"
          className="topbar-menu-toggle"
          onClick={handleToggleMainMenu}
          aria-label="Abrir menu"
          title="Abrir menu"
        >
          <i className="fas fa-bars" />
        </button>
      </div>

      {/* DIREITA — Nome + Avatar */}
      <div className="topbar-right" ref={menuRef}>
        <span className="topbar-admin-name">{adminName}</span>

        <button
          type="button"
          className="topbar-avatar"
          onClick={() => setOpenMenuUser((prev) => !prev)}
          aria-label="Menu do usuário"
          title="Menu do usuário"
        >
          <span>A</span>
        </button>

        {openMenuUser && (
          <div className="topbar-dropdown">
            <button type="button" onClick={() => setOpenMenuUser(false)}>
              <i className="fas fa-user" /> Meu Perfil
            </button>

            <button type="button" onClick={() => setOpenMenuUser(false)}>
              <i className="fas fa-shield-alt" /> Acessos
            </button>

            <button type="button" onClick={handleLogout} className="logout-btn">
              <i className="fas fa-sign-out-alt" /> Sair
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
